export default __webpack_public_path__ + "img/InterDisplay-ExtraBold_afbed0c.woff2";